import React, { useContext, useState, useRef, useEffect } from 'react'
import classNames from 'classnames'
import * as userAuth from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import QuickEdit from 'component/imageAction/quickEdit'
import { ImageDetailContext } from '../../content'
import Dynamic from './dynamic'
import InfoLabel from './label'
import InfoDetail from './detail'
import OriginalText from './originalText'
import InfoFooter from './footer'
import PatternElement from './label/patternElement'
import { getElement } from './label/element'
import type { IImageDetailContext } from '../../content'
import styles from './index.module.less'

interface InfoProps {
  imgInfoList: Array<any>
  hasZkOfficialStyle: boolean
}

export default ({ imgInfoList, hasZkOfficialStyle }: InfoProps) => {
  const {
    currentImage,
    queryParams,
    boxIndex,
    setBoxIndex,
    upgradeInfo,
    onDeleteItem,
    setBanOperation,
    onInit,
    initWaterfall,
    onVisibleChange,
    onChange,
    onInitCommentTotal,
    runImgsData,
  } = useContext<IImageDetailContext>(ImageDetailContext)

  const dynamicRef = useRef(null)
  const elements = currentImage?.boxLabelRetList ? currentImage?.boxLabelRetList?.[boxIndex] || {} : {}
  const { show } = getElement(elements)
  const [quickEditVisible, setQuickEditVisible] = useState(false)
  const auth = currentImage.loginUserInfo?.inspirationPermissions || []
  const { patternAbroadDTO } = currentImage

  useEffect(() => {
    if (quickEditVisible) {
      setBanOperation?.(true)
    } else {
      setBanOperation?.(false)
    }
  }, [quickEditVisible])

  const renderStyleTitleText = () => {
    if (upgradeInfo?.styleTitle) {
      return <div style={{ marginTop: '12px', wordBreak: 'break-all' }}>{upgradeInfo?.styleTitle}</div>
    }

    if (!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle) {
      return <div className={styles.infoStyleName}>款式名称</div>
    }
    return (
      <div className={styles.infoStyleName} onClick={() => setQuickEditVisible(true)}>
        <Icon type="m-bianji" style={{ marginRight: '4px' }} />
        点此添加款式名称
      </div>
    )
  }

  const renderStyleDescText = () => {
    if (upgradeInfo?.styleDesc) {
      return <div style={{ marginTop: '12px', wordBreak: 'break-all' }}>{upgradeInfo?.styleDesc}</div>
    }
    if (!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) || hasZkOfficialStyle) {
      return <div className={styles.infoStyleName}>款式描述</div>
    }
    return (
      <div className={styles.infoStyleName} onClick={() => setQuickEditVisible(true)}>
        <Icon type="m-bianji" style={{ marginRight: '4px' }} />
        点此添加款式描述
      </div>
    )
  }

  return (
    <>
      <div className={styles.mnImageDetailInfoViewContent}>
        {!hasZkOfficialStyle && <OriginalText currentImage={currentImage} />}
        <div className={classNames(styles.infoBlock, 'mt32')}>
          <div className={styles.titleLine}>
            <div className={styles.point} />
            <div className={styles.mainTitle}>款式名称</div>
            {upgradeInfo?.styleTitle && (
              <div className={styles.mainTitleRight}>
                {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) ||
                hasZkOfficialStyle ? null : (
                  <div className={classNames(styles['edit-info-btn'], 'fill-white-bg')} onClick={() => setQuickEditVisible(true)}>
                    <Icon type="m-kuaisubianji" style={{ marginRight: 2, fontSize: '16px' }} />
                    编辑
                  </div>
                )}
              </div>
            )}
          </div>
          {renderStyleTitleText()}
        </div>
        <div className={classNames(styles.infoBlock, 'mt32')}>
          <div className={styles.titleLine}>
            <div className={styles.point} />
            <div className={styles.mainTitle}>款式描述</div>
            {upgradeInfo?.styleDesc && (
              <div className={styles.mainTitleRight}>
                {!userAuth.isPermissions(auth, ['FS05', 'FS05_CREATOR', 'FCS06', 'FCS06_CREATOR']) ? null : (
                  <div className={classNames(styles['edit-info-btn'], 'fill-white-bg')} onClick={() => setQuickEditVisible(true)}>
                    <Icon type="m-kuaisubianji" style={{ marginRight: 2, fontSize: '16px' }} />
                    编辑
                  </div>
                )}
              </div>
            )}
          </div>
          {renderStyleDescText()}
        </div>
        {show && <InfoLabel currentImage={currentImage} boxIndex={boxIndex} setBoxIndex={setBoxIndex} />}
        <PatternElement patternAbroadDTO={patternAbroadDTO} />
        {userAuth.isPermissions(auth, ['FS16']) && !hasZkOfficialStyle && (
          <div className={classNames(styles.infoBlock, 'mt32')}>
            <div className={styles.titleLine}>
              <div className={styles.point} />
              <div className={styles.mainTitle}>款式动态</div>
            </div>
            <div className={styles.infoBlockContext}>
              <Dynamic ref={dynamicRef} queryParams={queryParams} currentImage={currentImage} setBanOperation={setBanOperation} />
            </div>
          </div>
        )}
        <InfoDetail
          setQuickEditVisible={setQuickEditVisible}
          currentImage={currentImage}
          queryParams={queryParams}
          hasZkOfficialStyle={hasZkOfficialStyle}
          onChange={onChange}
        />
      </div>
      <InfoFooter
        runImgsData={runImgsData}
        onInitCommentTotal={onInitCommentTotal}
        setQuickEditVisible={setQuickEditVisible}
        hasZkOfficialStyle={hasZkOfficialStyle}
        currentImage={currentImage}
        imgInfoList={imgInfoList}
        onInit={() => {
          dynamicRef.current?.onInit()
          onInit()
        }}
        onChange={onChange}
        queryParams={queryParams}
        setBanOperation={setBanOperation}
        initWaterfall={initWaterfall}
        onVisibleChange={onVisibleChange}
        boxIndex={boxIndex}
        onDeleteItem={onDeleteItem}
      />
      <QuickEdit
        itemData={upgradeInfo}
        imageGroupEntityId={queryParams.blogId as string}
        visible={quickEditVisible}
        onVisibleChange={(vis) => setQuickEditVisible(vis)}
        onDeleteItem={onDeleteItem}
        inspirationId={queryParams.inspirationId as number}
        setBanStatus={setBanOperation}
        onChange={(success, newItemData) => {
          onChange?.(success, newItemData)
          onInit()
        }}
      />
    </>
  )
}
